import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Newsletter from "@/components/site/Newsletter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDate(d) {
    try {
        return new Date(d).toLocaleDateString("en-AU", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    } catch {
        return "";
    }
}

export default function InsightsIndex() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        axios
            .get(`${API}/posts?limit=100`)
            .then((r) => alive && setPosts(r.data || []))
            .catch(() => alive && setPosts([]))
            .finally(() => alive && setLoading(false));
        return () => {
            alive = false;
        };
    }, []);

    return (
        <main data-testid="insights-page" className="bg-bone text-ink">
            <Nav />

            <section className="pt-32 md:pt-40 lg:pt-44 pb-20 md:pb-28">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                    <div className="flex items-center gap-4 mb-10">
                        <span className="block w-10 h-px bg-ochre" />
                        <span className="eyebrow text-ink2">
                            Notes from the work on Country
                        </span>
                    </div>
                    <h1
                        data-testid="insights-page-heading"
                        className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tight text-ink max-w-5xl"
                    >
                        Insights, essays
                        <br />
                        and{" "}
                        <em className="italic font-light text-eucalyptus">
                            field notes.
                        </em>
                    </h1>
                </div>
            </section>

            <section className="pb-24 md:pb-32 lg:pb-40">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                    <div
                        data-testid="insights-page-list"
                        className="border-t border-rule"
                    >
                        {loading &&
                            [0, 1, 2].map((i) => (
                                <div
                                    key={i}
                                    className="border-b border-rule py-10 animate-pulse"
                                >
                                    <div className="h-3 w-24 bg-rule mb-4" />
                                    <div className="h-8 w-2/3 bg-rule mb-3" />
                                    <div className="h-4 w-full bg-rule" />
                                </div>
                            ))}
                        {!loading &&
                            posts.map((p) => (
                                <Link
                                    key={p.slug}
                                    to={`/insights/${p.slug}`}
                                    data-testid={`insight-row-${p.slug}`}
                                    className="block border-b border-rule py-10 md:py-12 group hover:bg-bone2 transition-colors px-2 md:px-4"
                                >
                                    <div className="grid grid-cols-12 gap-6 items-baseline">
                                        <div className="col-span-12 md:col-span-3">
                                            <span className="number-mark text-ochre">
                                                {p.category || "Note"}
                                            </span>
                                            <p className="mt-2 text-[12px] tracking-wide text-ink2">
                                                {formatDate(p.published_at)}
                                            </p>
                                        </div>
                                        <div className="col-span-12 md:col-span-7">
                                            <h2 className="font-serif text-3xl md:text-4xl leading-[1.08] text-ink group-hover:text-ochre transition-colors">
                                                {p.title}
                                            </h2>
                                            <p className="mt-4 text-ink2 leading-relaxed max-w-2xl">
                                                {p.excerpt}
                                            </p>
                                        </div>
                                        <div className="col-span-12 md:col-span-2 md:text-right">
                                            <span className="eyebrow text-ink2 group-hover:text-ochre transition-colors">
                                                Read →
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        {!loading && posts.length === 0 && (
                            <div className="border-b border-rule py-12 text-ink2">
                                Insights coming soon.
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <Newsletter />
            <Footer />
        </main>
    );
}
